// extracted by mini-css-extract-plugin
module.exports = {"products":"tV","productContainer":"uV","overFlowVisible":"vV","resultsHeading":"wV","oosMessaging":"xV","bestExp":"yV","bestExpRecognized":"zV","bestExpMobile":"AV"};